import { useCallback } from 'react';

import { parseStrInArray } from '@interlayer/js/app/utils/common.util';

import {
    B_TAG,
    B_TAG_AND_PHASE,
    PHASE,
    WITHOUT_SEGMENTATION
} from '../constants';

import { useCheckSegmentation } from './useCheckSegmentation';

export const useFindAdditionalConfig = () => {
    const checkSegmentation = useCheckSegmentation();

    return useCallback(({ id, overwriteConfig }) => {
        const rewrittenConfigs: Record<string, string> = {};
        const rewrittenConfigsByDataId: Record<string, string> = {};

        for (let i = 0; i < overwriteConfig.length; i++) {
            const data = overwriteConfig[i];
            const { dataId: dataIds, bTag, phases } = data;
            const dataId = parseStrInArray(dataIds).find((currentId: string) => id === currentId);

            if (!dataId) {
                continue;
            }

            const segmentationData = checkSegmentation({ bTag, phases });

            if (!segmentationData) {
                continue;
            }

            if (dataId && segmentationData.length === 2) {
                // if there is all data on segmentation, then immediately return
                return data;
            }

            if (dataId) {
                rewrittenConfigsByDataId[segmentationData[0]] = data;
            } else if (segmentationData.length === 2) {
                rewrittenConfigs[B_TAG_AND_PHASE] = data;
            } else {
                rewrittenConfigs[segmentationData[0]] = data;
            }
        }

        return rewrittenConfigs[B_TAG_AND_PHASE]
            || rewrittenConfigsByDataId[B_TAG]
            || rewrittenConfigs[B_TAG]
            || rewrittenConfigsByDataId[PHASE]
            || rewrittenConfigs[PHASE]
            || rewrittenConfigsByDataId[WITHOUT_SEGMENTATION]
            || rewrittenConfigs[WITHOUT_SEGMENTATION]
            || {};
    }, [checkSegmentation]);
};
